import React, { Component, Fragment } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";
import {standardActions} from '../../../Utils/Grid/StandardActions';


export default class GridMateriaPrima extends Component {

    render() {
        const { loader, data, page, listar, onPageChange, onSortChange} = this.props;
        const es_mes_actual = data.es_mes_actual;

        return (
            <Fragment>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    page={page}
                    className="reporte-table"
                    onPageChange={listar} onSortChange={onSortChange}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="id"
                        dataSort
                        className='reporte-table'
                        dataFormat={
                            standardActions({  ver: 'costos_inventario' })
                        }
                        width="10%"
                    />
                    <TableHeaderColumn
                        dataField="nombre"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell, row) => (
                            cell ? cell : "Sin registro"
                        )}
                    >
                        PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="costo"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell, row) => (
                            cell || cell == 0 ? <RenderMoneda monto={cell} decimalScale={cell == 0 ? 2 : 4}/> : "Sin registro" 
                        )}
                    >
                        COSTO BRUTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cantidad_inicial"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell) => ( cell  || cell == 0 ? cell : "Sin registro" )}
                    >
                        CANTIDAD INICIAL
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cantidad_mes"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell) => ( cell  || cell == 0 ? cell : "Sin registro" )}
                    >
                        INVENTARIO MES
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="consumido"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell) => ( cell  || cell == 0 ? cell : "Sin registro" )}
                    >
                        CONSUMIDO MES
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="existencias_actual"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell, row) => {
                            if(row.tiene_reajuste == 0){
                                return ( cell  || cell == 0 ? cell : "Sin registro" )
                            }
                            else{
                                return ( cell  || cell == 0 ?
                                <span className="t-mostaza font-weight-bold">
                                    { es_mes_actual ? row.existencias_actual : row.existencias_anterior}
                                </span> 
                                : "Sin registro" )
                            }
                            }}
                    >
                        EXISTENCIAS
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="costo_total_actual"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell, row) => ( cell  || cell == 0 ? <RenderMoneda monto={es_mes_actual ? row.costo_total_actual : row.costo_total_anterior}/> : "Sin registro" )}
                    >
                        COSTO TOTAL
                    </TableHeaderColumn>
                </Grid>
            </Fragment>
        )
    }

}
